// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nn-0";